import ReCAPTCHA from 'react-google-recaptcha'
import React, { forwardRef, useEffect, useState } from 'react'
import { useMediaQuery } from 'hooks/useMediaQuery'

export const Captcha = forwardRef(function Captcha(
  { onChange = function () {}, style },
  ref,
) {
  const isMobile = useMediaQuery('(max-width:499px)')
  const [recaptchaValue, setRecaptchaValue] = useState(null)
  console.log('🚀 ~ recaptchaValue:', recaptchaValue)

  useEffect(() => {
    onChange(recaptchaValue)
  }, [recaptchaValue])

  const changeHandler = e => {
    setRecaptchaValue(e)
  }

  return (
    <ReCAPTCHA
      style={style}
      size={isMobile ? 'compact' : 'normal'}
      // asyncScriptOnLoad={onLoaded}
      ref={ref}
      sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
      onChange={changeHandler}
    />
  )
})
